<template>
  <!-- Apply base Tailwind styles and layout -->
  <VariablesCSS />
  <div id="app" class="flex h-screen bg-gray-100 font-sans text-gray-900">
    <!-- PrimeVue Toast component for notifications -->
    <Toast position="top-right" />

    <!-- Main Content Area -->
    <div class="flex-1 flex flex-col overflow-hidden">

      <!-- Content -->
      <main class="flex-1 overflow-x-hidden overflow-y-auto bg-gray-100 relative">
        <!-- PrimeVue Progress Spinner for Loading State -->
        <div v-if="isLoading" class="absolute inset-0 bg-gray-500 bg-opacity-50 flex items-center justify-center z-50">
          <ProgressSpinner style="width: 50px; height: 50px" strokeWidth="8" animationDuration=".5s" aria-label="Loading" />
        </div>

        <!-- Global notifications (Keep for now, style later) -->
        <!-- <notification-container position="top-right" class="z-40 fixed top-4 right-4" /> -->

        <!-- Router View with Transitions -->
        <router-view v-slot="{ Component }">
          <transition name="page" mode="out-in">
            <component :is="Component" />
          </transition>
        </router-view>
      </main>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import ProgressSpinner from 'primevue/progressspinner';
import Toast from 'primevue/toast';

// Access store and map getters if needed (Composition API way)
const store = useStore();
const isLoading = computed(() => store.getters.isLoading);
</script>

<style>
/* Optional: Add styles to customize PanelMenu appearance if needed */
.p-panelmenu .p-panelmenu-header-link {
  border-radius: 0; /* Example: Remove border radius */
  border-left: none;
  border-right: none;
}

.p-panelmenu .p-menuitem-link {
   border-radius: 0;
   border-left: none;
   border-right: none;
}

/* Keep page transitions */
.page-enter-active,
.page-leave-active {
  transition: opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1),
              transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.page-enter-from,
.page-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

html, body {
  margin: 0;
  padding: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', sans-serif;
  background-color: #f5f5f5;
}

#app {
  width: 100%;
  min-height: 100vh;
}
</style>
